import React from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";

import Select from "components/Select";
import Button from "components/Button";
import Label from "components/Label";

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

  const organization = useOrganizations();

  return (
    <Grid.Row style={{
      flex: "1",
    }} gutter={[16, 8]} align="bottom">
      <Grid.Col xs={12}>
        <Label title={t(`column_organization`)}>
          <Select
            showSearch
            onChange={v => setParams({ organization_id: v })}
            options={[
              { label: t("all_organization"), value: "" },
              ...organization.items.map(item => ({
                label: item.name[i18n.language],
                value: item.id,
              })),
            ]}
            value={Number(params.organization_id) || ""}
            placeholder={t("column_organization")}
            disabled={!organization.isFetched}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={3}>
        <Button
          style={{ width: "100%" }}
          background="blue"
          color="white"
          border="blue"
          radius="sm"
          onClick={() => setSearch(prev => prev + 1)}>
          <Icons.Search /> {t("find")}
        </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;
